/**
 * A provider "pick" row — prototype/integrations-frames.js's `.pk` pattern.
 * Used identically in three places: the first-run empty state, the "Add
 * integration" picker sheet, and (later) its mobile bottom-sheet variant.
 * Not the OAuth brand sign-in button (that only appears on the connect
 * page itself, after a provider is picked here) — this is a plain list-row
 * affordance: mark, name (+ optional badge), description, trailing arrow.
 */
import React from "react";
import classNames from "classnames";
import Badge from "../../theme/untitled/Badge/Badge";
import Icon from "../../theme/untitled/icons/Icon";
import { AvailableIntegrations } from "../../consts/integrations";
import styles from "./ProviderPickRow.module.scss";

const ProviderPickRow = ({
  provider,
  title,
  description,
  badge,
  disabled,
  onClick,
}) => {
  const meta = AvailableIntegrations.find((i) => i.type === provider);

  return (
    <button
      type="button"
      className={classNames(styles.pick, { [styles.disabled]: disabled })}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={styles.mark}>
        {meta ? (
          <img src={`/img/integrations_icons/${meta.icon}`} alt={title} />
        ) : null}
      </span>
      <span className={styles.text}>
        <span className={styles.titleRow}>
          <b>{title}</b>
          {badge && (
            <Badge color={badge.color} size="sm">
              {badge.label}
            </Badge>
          )}
        </span>
        <p>{description}</p>
      </span>
      {!disabled && (
        <span className={styles.go}>
          <Icon name="ArrowRight" size={20} />
        </span>
      )}
    </button>
  );
};

export default ProviderPickRow;
